import { Component, effect, inject, Input } from '@angular/core';
import { Items } from 'tilby-models';
import { ItemPrintersFormGroups } from './item-printers.model';
import { ChildNotificationInterface, ItemCommunicationService, ParentNotificationInterface, ParentTriggerInterface } from 'src/app/features/items/components/items-module/items-tab/services/item-communication.service';
import { ItemPrinterFormService } from './item-printers-form.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-item-printers',
  standalone: true,
  imports: [ MatFormFieldModule, ReactiveFormsModule,
      TranslateModule, FormsModule, CommonModule,
      MatInputModule, MatCheckboxModule
  ],
  templateUrl: './item-printers.component.html',
  styleUrl: './item-printers.component.scss'
})
export class ItemPrintersComponent {

  private readonly itemCommunicationService = inject(ItemCommunicationService);
  readonly itemPrintersFormService = inject(ItemPrinterFormService);
  
  @Input() item!: Items;

  itemPrinterForm!: ItemPrintersFormGroups;

  constructor() {
    effect(() => {
      // Listener per eseguire operazioni richieste dal parent
      const trigger = this.itemCommunicationService.parentTrigger();
      if(trigger?.child === 'printers' || trigger?.child === 'all') {
        this.handleParentTrigger(trigger);
      }
    })

    effect(() => {
      // Listener per leggere notifiche inviate dal parent
      const notification = this.itemCommunicationService.parentNotifier();
      if (notification?.child === 'printers') {
        this.handleParentNotification(notification);
      }
    })

  }

  handleParentTrigger(message: ParentTriggerInterface) {
    if (message.trigger === 'tabActivated') {
      this.requestGeneralFormData();
    }
    
    if(message.trigger === 'cancel') {
      this.itemPrintersFormService.resetFormValues(this.item);
    }
  }

  requestGeneralFormData() {
    setTimeout(() => {
      this.itemCommunicationService.createParentTrigger('requestGeneralData', 'general', 'printers', { formField: 'category' })
    })
  }

  handleParentNotification(message: ParentNotificationInterface) {
    if(message.notification === 'generalData') {
      this.itemPrintersFormService.updateCategoryField(message.params?.category || -1);
    }
  }

  ngOnInit(): void {
    this.itemPrinterForm = this.itemPrintersFormService.createForm(this.item);

    // this.itemPrinterForm.valueChanges.pipe().subscribe(() => {
    //   console.log("itemStockForm changed: ", this.itemPrinterForm);
    // })
  }


  sendNotificationToParent(notification: ChildNotificationInterface) {
    Promise.resolve().then(() => {
      this.itemCommunicationService.notifyParent(notification);
    });
  }
}
